import React from "react";

import { AccountFormProps } from "../types";
import SimpleInput from "../../input/SimpleInput";
import Button from "../../button/Button";
import FORMS from "../../constants/forms";

import styles from "./accountForm.module.css";

const AccountForm = ({
  handleUpdateDetails,
  userProfile,
  handleEditClick,
}: AccountFormProps): JSX.Element => {
  const SubmitButton = () => {
    return (
      <div className={styles.button}>
        <Button type="submit" text="Update" />
      </div>
    );
  };
  const formData = {
    ...FORMS.ACCOUNT,
    initialValues: {
      title: userProfile?.title || "",
      firstName: userProfile?.firstName || "",
      lastName: userProfile?.lastName || "",
      babyName: userProfile?.babyName || "",
      email: userProfile?.email || "",
      contactNumber: userProfile?.contactNumber || "",
      address1: userProfile?.address1 || "",
      address2: userProfile?.address2 || "",
      city: userProfile?.city || "",
      postcode: userProfile?.postcode || "",
      country: userProfile?.country || "",
    },
    handleSubmit: handleUpdateDetails,
    submitButton: SubmitButton,
  };

  return (
    <div className={styles.container}>
      <div className={styles.details}>
        <div className={styles.title}> Personal Details</div>
      </div>
      <div className={styles.formContainer}>
        <SimpleInput
          data={formData}
          inputStyle="square"
          requiredFieldsLabel={true}
        />
        <div className={styles.cancelButton}>
          <Button onClick={handleEditClick} text="Cancel" />
        </div>
      </div>
    </div>
  );
};

export default AccountForm;
